export const scrollToIdMixin = {
  methods: {
    scrollToId() {
      // scroll to id
      const id = "response_message";
      const yOffset = -100;
      const element = document.getElementById(id);
      const y =
        element.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({ top: y, behavior: "smooth" });
    },
  },
};

export const reCaptchaMixin = {
  data() {
    return {
      reCpatcha: "",
    };
  },
  methods: {
    onVerify: function(response) {
      this.reCpatcha = response;
    },
    onExpired: function() {
      this.reCpatcha = "";
    },
    onRender: function(id) {
      let reCaptcha = document.querySelector(".cyb-recaptcha");
      if (reCaptcha) {
        reCaptcha.style.display = "flex";
        setTimeout(() => {
          reCaptcha.style.display = "block";
        }, 1000);
      }
    },
    resetRecaptcha() {
      this.$refs.recaptcha.reset(); // Direct call reset method
    },
  },
};

export const refererApiMixin = {
  methods: {
    async sendRefererToApi() {
      let formData = new FormData();

      // create a json object from values to send to API
      let data = {
        web: this.web,
        app: this.app,
        mobile: this.mob,
      };

      formData.append("data", JSON.stringify(data));
      //setup headers, method and values
      const settings = {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
          "X-Requested-With": "XMLHttpRequest",
        },
      };
      this.axios
        .post(
          process.env.VUE_APP_WEBSERVICE_URL + "/?action=pageload",
          formData,
          settings
        )
        .then(
          // get response if success
          async (dataRes) => {
            return dataRes;
          }
          // catch the errors
        )
        .catch(function(error) {
          console.log(error);
        });
    },
  },
};

export const gbChildMixin = {
  methods: {
    // that method allows us to set component for the first GB child if GB is clicked/true
    addFirstChild() {
      // check if there are already children in gb, if not then call function addChild
      if (this.gb.gb_childs.length == 0) {
        this.addChild();
      }
      // if GB checkbox is clicked/false then remove children from array
      if (!this.gb.isVisible) {
        this.gb.gb_childs = [];
      }
    },
    // add childs method
    addChild() {
      // check if there are children less or equal to 4
      if (this.gb.gb_childs.length <= 4) {
        // if its less or equal, then push one more to array gb.childs
        this.gb.gb_childs.push({
          name: "",
          month: {
            isVisible: false,
            value: null,
          },
          year: {
            isVisible: false,
            value: null,
          },
          validationSuccess: false,
        });
      }
    },
    // generate children array for db
    generateChildrenArray() {
      this.gb.gb_child_db = [];
      let germanMonths = [
        "Jänner",
        "Februar",
        "März",
        "April",
        "Mai",
        "Juni",
        "Juli",
        "August",
        "September",
        "Oktober",
        "November",
        "Dezember",
      ];

      for (let child of this.gb.gb_childs) {
        this.gb.gb_child_db.push({
          name: child.name,
          month: germanMonths.indexOf(child.month.value) + 1,
          year: child.year.value != null ? child.year.value : 0,
        });
      }
    },
    // method to remove child from gb.childs
    removeChild(index) {
      // check if there are children less or equal to 1
      if (this.gb.gb_childs.length >= 1) {
        // if its the case, then remove child from array gb.childs
        this.gb.gb_childs.splice(index, 1);
      }
    },
  },
};
